import ApiService from './api.service'

const DashboardService = {
  index (currentTimeline = 'default') {
    return ApiService.get('api/v1/admin/dashboard', {
      params: {
        currentTimeline
      }
    })
  },
  getLeagues (currentTimeline = 'default') {
    return ApiService.get('api/v1/admin/dashboard/leagues', {
      params: {
        currentTimeline
      }
    })
  },
  currentSeasonSchedules () {
    return ApiService.get('api/v1/admin/current-season-schedules')
  },
  getGamesToSchedule (scheduleUuid, params) {
    return ApiService.get('api/v1/admin/games-to-schedule', {
      params: {
        schedule: scheduleUuid,
        ...params
      }
    })
  },
  getGamesCalendar (fromDate, toDate, currentTimeline, venue, schedule) {
    return ApiService.get('api/v1/admin/games-calendar', {
      params: {
        fromDate,
        toDate,
        currentTimeline,
        venue,
        schedule
      }
    })
  },
  getCalendarVenues () {
    return ApiService.get('api/v1/admin/calendar-venues')
  },
  exportScheduledGamesCsv (data) {
    return ApiService.postWithoutLoading('api/v1/admin/dashboard/export-scheduled-games-csv', data)
  },
  finishedGames () {
    return ApiService.get('api/v1/admin/user/finished-games')
  },
  generateCode (gameUuid) {
    return ApiService.postWithoutLoading(`api/v1/admin/dashboard/generate-code/${gameUuid}`)
  },
  swapGameTimeAndVenue (game1Uuid, game2Uuid) {
    console.log('game1Uuid', game1Uuid)
    console.log('game2Uuid', game2Uuid)
    return ApiService.postWithoutLoading('api/v1/admin/dashboard/swap-games', {
      game1Uuid,
      game2Uuid
    })
  },
  publishTimeline (timelineId) {
    return ApiService.postWithoutLoading(`api/v1/admin/dashboard/timeline/${timelineId}/publish`)
  }
}

export default DashboardService
